import { render, staticRenderFns } from "./caseTitle.vue?vue&type=template&id=241c031e&lang=pug"
import script from "./caseTitle.vue?vue&type=script&lang=js"
export * from "./caseTitle.vue?vue&type=script&lang=js"
import style0 from "./caseTitle.vue?vue&type=style&index=0&id=241c031e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports